import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { Box, Button, DialogActions, DialogContent, DialogContentText, Slider } from '@mui/material';
import apiManagerRoom from 'api/manager-meeting';
import { API_DOMAIN } from 'constants/api';
import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import AvatarEditor from 'react-avatar-editor';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setUserInfo } from 'store/user/userInfoSlice';
import { TOAST_DEFAULT } from 'constants/toast';
import { reduceFileSize } from 'utils/functions/images';
import { setCloseDialogCC, toastError, toastSuccess } from 'utils/helpers';
import { ReactComponent as IconRotato } from '../../assets/svg/IconRotato.svg';
import { DIALOG_ID } from './constant';
import DialogBaseCC from './DialogBaseCC';


const DialogEditImages = () => {
    const userInfo = useSelector((state) => state.userInfo.userInfo, _.isEqual);
    const propsDialog = useLegacyDialogProps();
    const { selectedFile } = propsDialog

    const { t } = useTranslation()
    const dispatch = useDispatch()

    const [rotateNumber, setRotateNumber] = useState(0)
    const [scale, setScale] = useState(1)
    const [src, setSrc] = useState(null);

    const avatarRef = useRef(null)

    const uploadAvatar = (data) => {
        return apiManagerRoom.uploadAvatar(data);
    };

    const handleSave = async () => {
        if (avatarRef.current) {
            const dataUrl = avatarRef.current.getImage().toDataURL();
            const file = dataURLtoBlob(dataUrl);

            reduceFileSize(file, 1024 * 1024, 1000, Infinity, 0.9, blob => {
                const fd = new FormData();

                fd.append('files', blob);
                fd.append('names', 'avatarNew');

                uploadAvatar(fd)
                    .then(res => {
                        toastSuccess(t('toast.updateProfileSuccess'))
                        dispatch(setUserInfo({ ...userInfo, images: API_DOMAIN + res.data.data }))
                        // dispatch(setCloseModal())
                        setCloseDialogCC()
                    })
                    .catch((err) => {
                        console.log("ERR: ", err);
                        toastError(t(TOAST_DEFAULT.ERROR))
                    })

    
            });
        }
    };


    function dataURLtoBlob(dataURL) {
        let array, binary, i, len;
        binary = atob(dataURL.split(',')[1]);
        array = [];
        i = 0;
        len = binary.length;
        while (i < len) {
            array.push(binary.charCodeAt(i));
            i++;
        }
        return new Blob([new Uint8Array(array)], {
            type: 'image/png'
        });
    };


    useEffect(() => {
        if (selectedFile) {
            setSrc(URL.createObjectURL(selectedFile.target.files[0]));
        }
    }, [selectedFile])

    return (
        <DialogBaseCC id={DIALOG_ID.EDIT_IMAGES} title={t('title.updateAvatar')}>
            <DialogContent>
                <DialogContentText>
                <div className='image-preview'>
                    <AvatarEditor
                        ref={avatarRef}
                        image={src}
                        style={{ width: "100%", height: "100%" }}
                        border={50}
                        borderRadius={150}
                        color={[0, 0, 0, 0.72]}
                        scale={scale}
                        rotate={rotateNumber}
                    />
                    <Box sx={{display: 'flex', justifyContent: 'center'}}>
                    <Box sx={{ width: 200 }}>
                        <Slider
                            sx={{color: (theme) => theme.palette.primary.main }}
                            min={1}
                            max={5}
                            step={0.1}
                            value={scale}
                            onChange={(event, newValue) => setScale(Number(newValue))}
                            disabled={!src}
                            aria-label="Small"
                            valueLabelDisplay="off"
                            size="medium"
                        />
                    </Box>
                    </Box>
                </div>
                <Box component={'div'} className='rotato-image' onClick={() => setRotateNumber((prev) => prev - 90)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', '& svg path': { fill: theme => theme.palette.primary.main }}}>
                    <IconRotato style={{ marginRight: 8 }} /> {t('actions.rotate')}
                </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='outlined' 
                    onClick={() => setCloseDialogCC()}
                >
                    {t("modal.cancel")}
                </Button>
                <Button
                    variant='contained' 
                    onClick={handleSave}
                >
                    {t("modal.confirm")}
                </Button>
            </DialogActions>
        </DialogBaseCC>
    );
};

export default DialogEditImages;
